import { Path } from 'enums';
import ProductModule from 'modules/product/product.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const ProductPage = () => {
  return (
    <Switch>
      <Route exact path={Path.Products} component={ProductModule} />
    </Switch>
  );
};

export default ProductPage;
